export const isCodeLongEnough = (code, validationConfig) => code.length >= validationConfig.code.minLength;
